module.exports = __webpack_public_path__ + "static/media/zolePlayed_100000_250000.d187964a.png";